import { render, staticRenderFns } from "./EmpAdvisorTemplate.vue?vue&type=template&id=637748a9&"
import script from "./EmpAdvisorTemplate.vue?vue&type=script&lang=js&"
export * from "./EmpAdvisorTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports